/** `action_status` nomenclature ids the backend counts as user activity errors (errors-per-hour series). */
export const USER_ACTION_STATUS_FAILURE = 2;
export const USER_ACTION_STATUS_ERROR = 3;
export const USER_ACTION_ERROR_STATUS_IDS = [
  USER_ACTION_STATUS_FAILURE,
  USER_ACTION_STATUS_ERROR,
];
